import { render } from "./DataImage.vue?vue&type=template&id=3baec229"
import script from "./DataImage.vue?vue&type=script&lang=js"
export * from "./DataImage.vue?vue&type=script&lang=js"

import "./DataImage.vue?vue&type=style&index=0&id=3baec229&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__